import React from 'react'
import { Button } from '@deal/components'
import styles from './styles.css'
import NotificationImage1x from './assets/notification.png'
import NotificationImage2x from './assets/notification@2x.png'
import NotificationImage3x from './assets/notification@3x.png'

interface Props {
  onDenyNotificaftions: () => void
  onAcceptNotifcations: () => void
}

const RequestPushNotifications: React.SFC<Props> = ({
  onAcceptNotifcations,
  onDenyNotificaftions
}) => {
  return (
    <div className={styles.page}>
      <div className={styles.header}>Enable notifications for free expert recommendations</div>
      <div className={styles.imageContainer}>
        <img
          src={NotificationImage1x}
          alt="Enable Push Notifications"
          className={styles.image}
          srcSet={`${NotificationImage1x}, ${NotificationImage2x} 2x, ${NotificationImage3x} 3x`}
        />
      </div>

      <div className={styles.actions}>
        <Button
          variant="secondary"
          size="large"
          type="button"
          className={styles.button}
          onClick={onDenyNotificaftions}
        >
          Later
        </Button>
        <Button
          variant="primary"
          size="large"
          type="button"
          className={styles.button}
          onClick={onAcceptNotifcations}
        >
          Enable Now
        </Button>
      </div>
    </div>
  )
}

export default RequestPushNotifications
